module.exports = __webpack_public_path__ + "img/stop-circle.4a6442b8.svg";